
const closePopupsButtonWatcher = () => {

	//Close popup
	const closePopupLinksOnPage = document.querySelectorAll('.js__close-popups'); //Get all popup links on page
	
	if(closePopupLinksOnPage.length > 0){ //Check if there are any links first
		closePopupLinksOnPage.forEach((closePopupLink) => { //Loop through each and give it a onclick event listener
			closePopupLink.addEventListener('click', (event) => {
				event.preventDefault(); //Stop the link firing normally !
				closeAllPopups();

				document.querySelector('body').classList.remove('js__popup-active');
				document.querySelector('body').dataset.popup = '';
			});
		});
	}
}

const openPopup = (targetPopupID) => {
	var targetPopup = document.querySelector(targetPopupID); //Select the popup
	if(targetPopup){ //Check we have a valid target popup
		console.log('Opening Popup: '+targetPopupID);

		closeAllPopups();//Make sure no popups are currently open
		targetPopup.classList.add('active'); //Activate the popup!
		document.querySelector('body').classList.add('js__popup-active'); //Add class to body to show popup is open
		document.querySelector('body').dataset.popup = targetPopupID;
		
		
	}else{
		console.warn('Missing Popup: '+targetPopupID);
	}
}


const closeAllPopups = () => {
	var openPopups = document.querySelectorAll('.popup.active');
	if(openPopups.length > 0){
		openPopups.forEach((openPopup) => {
			openPopup.classList.remove('active');
		});
	}
	let regionsPopups = document.querySelectorAll('.m__llist__regions');
	if(regionsPopups){
		regionsPopups.forEach((regionsPopup) => {
			regionsPopup.classList.remove('active');
		})
	}
}


const triggerCustomPopups = () => {
	//Function to launch any custom popups
	let customPopups = document.querySelectorAll('.popup.custom-popup');

	if(customPopups.length > 0){ //Check if there are any links first
		customPopups.forEach((customPopup) => {
			let displayType 	= customPopup.dataset.type,
				displayPages 	= customPopup.dataset.pages,
				displayPeriod 	= customPopup.dataset.period,
				currentPageID   = document.querySelector('body').dataset.page,
				triggerPopup   	= false;


			if(displayType != 'trigger'){ //Ignore if manually triggered
				//First check if the visitor already has the cookie, or if the popup is set to always display
				if(displayPeriod == 0){
					triggerPopup = true;
				}else{
					let hasCookie = getCookie(customPopup.getAttribute('id'));
					if(hasCookie){
						//User has cookie, don't show the popup
					}else{
						triggerPopup = true;
					}
				}


				//If we're in the trigger period, check to see if we're on the right page
				if(triggerPopup){ //No point continuing if they failed the period check!
					if(displayType == 'all'){
						triggerPopup = true;
					}else if(displayType == 'exclude' && !(displayPages.includes(currentPageID)) && currentPageID != ""){
						triggerPopup = true;
					}else if(displayType == 'include' && displayPages.includes(currentPageID) && currentPageID != ""){
						triggerPopup = true;
					}else{
						triggerPopup = false;
					}
				}

				if(triggerPopup){ //Show the popup and add a cookie if needed
					openPopup('#'+customPopup.getAttribute('id'));
					if(displayPeriod > 0){
						setCookie(customPopup.getAttribute('id'),true,displayPeriod);
					}
				}
			}
		});
	}	
}

//Set, get & delete cookies
const setCookie = (name,value,days) => {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
const  getCookie = (name) => {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
const  eraseCookie = (name) => {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}